import { takeEvery, put, call } from "redux-saga/effects"
import { NotifHelper } from "../../components/Common/NotifHelper"
import fileDownload from 'js-file-download'

// Calender Redux States
import {
    GET_REPORT_EXCEL,
    GET_REPORT_PDF,
    GET_REPORT_PROFITLOSS_EXCEL,
    GET_REPORT_PROFITLOSS_PDF,
    PREVIEW_REPORT_PDF,
    PREVIEW_REPORT_PROFITLOSS_PDF,
    GET_LKPM_REPORT_EXCEL,
    GET_LKPM_REPORT_PDF,
    PREVIEW_LKPM_REPORT_PDF,
    GET_LKPM_REPORT_PROFITLOSS_EXCEL,
    GET_LKPM_REPORT_PROFITLOSS_PDF,
    PREVIEW_LKPM_REPORT_PROFITLOSS_PDF,
} from "./actionTypes"
import {
    getReportExcelSuccess,
    getReportExcelFail,
    getReportPdfSuccess,
    getReportPdfFail,
    getReportProfitLossExcelSuccess,
    getReportProfitLossExcelFail,
    getReportProfitLossPdfSuccess,
    getReportProfitLossPdfFail,
    previewReportPdfSuccess,
    previewReportPdfFail,
    previewReportProfitLossPdfSuccess,
    previewReportProfitLossPdfFail,
    getLkpmReportExcelSuccess,
    getLkpmReportExcelFail,
    getLkpmReportPdfSuccess,
    getLkpmReportPdfFail,
    previewLkpmReportPdfSuccess,
    previewLkpmReportPdfFail,
    getLkpmReportProfitLossExcelSuccess,
    getLkpmReportProfitLossExcelFail,
    getLkpmReportProfitLossPdfSuccess,
    getLkpmReportProfitLossPdfFail,
    previewLkpmReportProfitLossPdfSuccess,
    previewLkpmReportProfitLossPdfFail,
} from "./actions"

//Include Both Helper File with needed methods
import {
    getReportExcel,
    getReportPdf,
    getReportProfitLossExcel,
    getReportProfitLossPdf,
    getLkpmReportExcel,
    getLkpmReportPdf,
    getLkpmReportProfitLossExcel,
    getLkpmReportProfitLossPdf,
} from "../../helpers/backend_helper"

function* onGetReportExcel({ payload: { param } }) {
    try {
        const response = yield call(getReportExcel, param, { responseType: 'blob' })
        let headerLine = response.headers['content-disposition'];
        let startFileNameIndex = headerLine.indexOf('=') + 1
        let endFileNameIndex = headerLine.lastIndexOf(';');
        let filename = headerLine.substring(startFileNameIndex, endFileNameIndex);
        fileDownload(response.data, filename)
        yield put(getReportExcelSuccess())
    } catch (error) {
        NotifHelper.error(error)
        yield put(getReportExcelFail(error))
    }
}

function* onGetReportPdf({ payload: { param } }) {
    try {
        const response = yield call(getReportPdf, param, { responseType: 'blob' })
        let headerLine = response.headers['content-disposition'];
        let startFileNameIndex = headerLine.indexOf('=') + 1
        let endFileNameIndex = headerLine.lastIndexOf(';');
        let filename = headerLine.substring(startFileNameIndex, endFileNameIndex);
        const file = new Blob([response.data], { type: "application/pdf" });
        fileDownload(file, filename)
        yield put(getReportPdfSuccess())
    } catch (error) {
        yield put(getReportPdfFail())
    }
}

function* onGetReportProfitLossExcel({ payload: { param } }) {
    try {
        const response = yield call(getReportProfitLossExcel, param, { responseType: 'blob' })
        let headerLine = response.headers['content-disposition'];
        let startFileNameIndex = headerLine.indexOf('=') + 1
        let endFileNameIndex = headerLine.lastIndexOf(';');
        let filename = headerLine.substring(startFileNameIndex, endFileNameIndex);
        fileDownload(response.data, filename)
        yield put(getReportProfitLossExcelSuccess())
    } catch (error) {
        NotifHelper.error(error)
        yield put(getReportProfitLossExcelFail(error))
    }
}

function* onGetReportProfitLossPdf({ payload: { param } }) {
    try {
        const response = yield call(getReportProfitLossPdf, param, { responseType: 'blob' })
        let headerLine = response.headers['content-disposition'];
        let startFileNameIndex = headerLine.indexOf('=') + 1
        let endFileNameIndex = headerLine.lastIndexOf(';');
        let filename = headerLine.substring(startFileNameIndex, endFileNameIndex);
        const file = new Blob([response.data], { type: "application/pdf" });
        fileDownload(file, filename)
        yield put(getReportProfitLossPdfSuccess())
    } catch (error) {
        yield put(getReportProfitLossPdfFail())
    }
}

function* onPreviewReportPdf({ payload: { param } }) {
    const accessToken = localStorage.getItem("AccessToken")
    var paramSend = { param: encodeURIComponent(JSON.stringify(param)), token: accessToken }
    try {
        var url = process.env.REACT_APP_API_URL + "/report/neraca/Preview?"+ new URLSearchParams(paramSend).toString()
        window.open(url, "_blank", "noreferrer")
        yield put(previewReportPdfSuccess())
    } catch (error) {
        yield put(previewReportPdfFail())
    }
}

function* onPreviewReportProfitLossPdf({ payload: { param } }) {
    const accessToken = localStorage.getItem("AccessToken")
    var paramSend = { param: encodeURIComponent(JSON.stringify(param)), token: accessToken }
    try {
        var url = process.env.REACT_APP_API_URL + "/report/profitloss/Preview?"+ new URLSearchParams(paramSend).toString()
        window.open(url, "_blank", "noreferrer")
        yield put(previewReportProfitLossPdfSuccess())
    } catch (error) {
        yield put(previewReportProfitLossPdfFail())
    }
}

function* onGetLkpmReportExcel({ payload: { param } }) {
    try {
        const response = yield call(getLkpmReportExcel, param, { responseType: 'blob' })
        let headerLine = response.headers['content-disposition'];
        let startFileNameIndex = headerLine.indexOf('=') + 1
        let endFileNameIndex = headerLine.lastIndexOf(';');
        let filename = headerLine.substring(startFileNameIndex, endFileNameIndex);
        fileDownload(response.data, filename)
        yield put(getLkpmReportExcelSuccess())
    } catch (error) {
        NotifHelper.error(error)
        yield put(getLkpmReportExcelFail(error))
    }
}

function* onGetLkpmReportPdf({ payload: { param } }) {
    try {
        const response = yield call(getLkpmReportPdf, param, { responseType: 'blob' })
        let headerLine = response.headers['content-disposition'];
        let startFileNameIndex = headerLine.indexOf('=') + 1
        let endFileNameIndex = headerLine.lastIndexOf(';');
        let filename = headerLine.substring(startFileNameIndex, endFileNameIndex);
        const file = new Blob([response.data], { type: "application/pdf" });
        fileDownload(file, filename)
        yield put(getLkpmReportPdfSuccess())
    } catch (error) {
        yield put(getLkpmReportPdfFail())
    }
}

function* onPreviewLkpmReportPdf({ payload: { param } }) {
    const accessToken = localStorage.getItem("AccessToken")
    var paramSend = { param: encodeURIComponent(JSON.stringify(param)), token: accessToken }
    try {
        var url = process.env.REACT_APP_API_URL + "/report/lkpm/Preview?"+ new URLSearchParams(paramSend).toString()
        window.open(url, "_blank", "noreferrer")
        yield put(previewLkpmReportPdfSuccess())
    } catch (error) {
        yield put(previewLkpmReportPdfFail())
    }
}

function* onGetLkpmReportProfitLossExcel({ payload: { param } }) {
    try {
        const response = yield call(getLkpmReportProfitLossExcel, param, { responseType: 'blob' })
        let headerLine = response.headers['content-disposition'];
        let startFileNameIndex = headerLine.indexOf('=') + 1
        let endFileNameIndex = headerLine.lastIndexOf(';');
        let filename = headerLine.substring(startFileNameIndex, endFileNameIndex);
        fileDownload(response.data, filename)
        yield put(getLkpmReportExcelSuccess())
    } catch (error) {
        NotifHelper.error(error)
        yield put(getLkpmReportExcelFail(error))
    }
}

function* onGetLkpmReportProfitLossPdf({ payload: { param } }) {
    try {
        const response = yield call(getLkpmReportProfitLossPdf, param, { responseType: 'blob' })
        let headerLine = response.headers['content-disposition'];
        let startFileNameIndex = headerLine.indexOf('=') + 1
        let endFileNameIndex = headerLine.lastIndexOf(';');
        let filename = headerLine.substring(startFileNameIndex, endFileNameIndex);
        const file = new Blob([response.data], { type: "application/pdf" });
        fileDownload(file, filename)
        yield put(getLkpmReportPdfSuccess())
    } catch (error) {
        yield put(getLkpmReportPdfFail())
    }
}

function* onPreviewLkpmReportProfitLossPdf({ payload: { param } }) {
    const accessToken = localStorage.getItem("AccessToken")
    var paramSend = { param: encodeURIComponent(JSON.stringify(param)), token: accessToken }
    try {
        var url = process.env.REACT_APP_API_URL + "/report-profitloss/lkpm/Preview?"+ new URLSearchParams(paramSend).toString()
        window.open(url, "_blank", "noreferrer")
        yield put(previewLkpmReportPdfSuccess())
    } catch (error) {
        yield put(previewLkpmReportPdfFail())
    }
}

function* reportSaga() {
    yield takeEvery(GET_REPORT_EXCEL, onGetReportExcel)
    yield takeEvery(GET_REPORT_PDF, onGetReportPdf)
    yield takeEvery(GET_REPORT_PROFITLOSS_EXCEL, onGetReportProfitLossExcel)
    yield takeEvery(GET_REPORT_PROFITLOSS_PDF, onGetReportProfitLossPdf)
    yield takeEvery(PREVIEW_REPORT_PDF, onPreviewReportPdf)
    yield takeEvery(PREVIEW_REPORT_PROFITLOSS_PDF, onPreviewReportProfitLossPdf)
    yield takeEvery(GET_LKPM_REPORT_EXCEL, onGetLkpmReportExcel)
    yield takeEvery(GET_LKPM_REPORT_PDF, onGetLkpmReportPdf)
    yield takeEvery(PREVIEW_LKPM_REPORT_PDF, onPreviewLkpmReportPdf)
    yield takeEvery(GET_LKPM_REPORT_PROFITLOSS_EXCEL, onGetLkpmReportProfitLossExcel)
    yield takeEvery(GET_LKPM_REPORT_PROFITLOSS_PDF, onGetLkpmReportProfitLossPdf)
    yield takeEvery(PREVIEW_LKPM_REPORT_PROFITLOSS_PDF, onPreviewLkpmReportProfitLossPdf)
}

export default reportSaga